/**
 * en-GB messages added by Phase 4 task S50 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s50EnGB = {
    'nav.id_checks': 'ID checks',
    'id_checks.error.dpia_required': 'Confirm your data protection impact assessment before turning on ID checks.',
    'id_checks.error.image_storage_off': 'Storing ID document images is switched off for this site.',
    'id_checks.error.image_too_large': 'The image is too large.',
    'id_checks.error.image_type': 'Only JPEG images are accepted.',
    'check.id_check.refused': 'Please see reception.',
    'check.id_check.warned': 'The ID check did not pass. Reception has been told.',
    'id_checks.annotation.checked': 'ID checked',
    'id_checks.annotation.failed': 'ID check failed',
    'id_checks.warning.invalid': 'The ID check result could not be read and was not saved.',
    'id_checks.warning.image_missing': 'The ID document image did not arrive and was not saved.',
    'id_checks.privacy.results': 'ID check results',
    'id_checks.privacy.kept_hold': 'Kept because the visit is under a legal hold.',
};
//# sourceMappingURL=s50.js.map